var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-lazy-image',{attrs:{"src":_vm.caseImage,"src-placeholder":require('@/assets/img/case-placeholder.svg'),"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }